import { render, staticRenderFns } from "./btn-primary.vue?vue&type=template&id=bc8220f4&scoped=true"
import script from "./btn-primary.vue?vue&type=script&lang=js"
export * from "./btn-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8220f4",
  null
  
)

export default component.exports